import config from './config'
import * as accountActions from './accounts'

const checkStatus = (response, resolve, reject) => {
  if (response.status >= 200 && response.status < 300) {
    response.json().then(json => resolve(json)).catch(() => resolve(response))
  } else if (response.status === 401) {
    if (localStorage.getItem('id_token') && !accountActions.isTokenValid(localStorage.getItem('id_token'))) {
      localStorage.removeItem('id_token')
      if (window.location.pathname !== '/login') {
        window.location.href = '/login'
      }
    }
    response
      .json()
      .then(json => {
        reject(json)
      })
      .catch(() => {
        let error = new Error(response.statusText)
        reject(error.message)
      })
  } else {
    response
      .json()
      .then(json => {
        reject(json)
      })
      .catch(() => {
        let error = new Error(response.statusText)
        reject(error.message)
      })
  }
}

const api = {
  get: (controller, routeParameter = '', queryParameters = '') => {
    return new Promise((resolve, reject) => {
      fetch(
        `${config.apiUrl}/${controller}${routeParameter !== '' ? '/' + routeParameter + '?' + queryParameters : queryParameters !== '' ? '?' + queryParameters : ''}`,
        {
          method: 'GET',
          headers: {
            'content-type': 'application/json',
            accept: 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('id_token'),
            Pragma: 'no-cache'
          }
        }
      )
        .then(response => checkStatus(response, resolve, reject))
        .catch(error => {
          reject(error.message)
        })
    })
  },
  post: (controller, parameter = '', data) => {
    return new Promise((resolve, reject) => {
      fetch(`${config.apiUrl}/${controller}${parameter && parameter !== '' ? '/' + parameter : ''}`, {
        method: 'POST',
        dataType: 'json',
        headers: {
          'content-type': 'application/json',
          accept: 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('id_token')
        },
        body: JSON.stringify(data)
      })
        .then(response => checkStatus(response, resolve, reject))
        .catch(error => {
          reject(error.message)
        })
    })
  },
  delete: (controller, parameter, queryParameters, data) => {
    return new Promise((resolve, reject) => {
      fetch(`${config.apiUrl}/${controller}${parameter && parameter !== '' ? '/' + parameter : ''}${queryParameters && queryParameters !== '' ? '?' + queryParameters : ''}`,{
        method: 'DELETE',
        dataType: 'jsonp',
        headers: {
          'content-type': 'application/json',
          accept: 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('id_token')
        },
        body: JSON.stringify(data)
      }).then(response => checkStatus(response, resolve, reject))
      .catch(error => {
        reject(error.message)
      })
    })
  },
  login: command => {
    return new Promise((resolve, reject) => {
      fetch(`${config.apiUrl}/account/login`, {
        method: 'POST',
        headers: { accept: 'application/json', 'content-type': 'application/json' },
        body: JSON.stringify(command)
      })
        .then(response => {
          checkStatus(
            response,
            o => {
              let token = response.headers.get('Authorization')
              if (token !== undefined && token !== null && token.length > 0) {
                localStorage.setItem('id_token', token.substring(7))
              }
              resolve(o)
            },
            reject
          )
        })
        .catch(error => {
          reject(error.message)
        })
    })
  }
}

export default api



// WEBPACK FOOTER //
// ./src/store/api.js